import { toast } from '../../common_components/Toast/ToastUtils';
import XLSX from 'xlsx-js-style';
const titleStyle = {
    font: { bold: true, sz: 20, color: { rgb: '181D27' } },
    alignment: { horizontal: 'center', vertical: 'center' },
};
const columnHeaderStyle = {
    font: { bold: true, sz: 11, color: { rgb: '374151' } },
    fill: { fgColor: { rgb: 'E5E7EB' } },
    alignment: { horizontal: 'center', vertical: 'center' },
};
const groupHeaderStyle = {
    font: { bold: true, sz: 12, color: { rgb: '1F2937' } },
    fill: { fgColor: { rgb: 'D1D5DB' } },
    alignment: { horizontal: 'center', vertical: 'center' },
};
const summaryRowStyle = {
    font: { bold: true, sz: 11, color: { rgb: '181D27' } },
    fill: { fgColor: { rgb: 'F3F4F6' } },
    alignment: { horizontal: 'right', vertical: 'center' },
};
const positiveVarianceStyle = {
    font: { color: { rgb: '027A48' } },
    alignment: { horizontal: 'center' },
};
const negativeVarianceStyle = {
    font: { color: { rgb: 'B42318' } },
    alignment: { horizontal: 'center' },
};
const MC_LABEL_MAP = {
    meta: 'Meta Ads',
    adword: 'Google Ads',
    ga: 'Google Analytics',
    shopify: 'Shopify',
    'Facebook Ads': 'Meta Ads',
};
export function exportAccountPerformance(rows, totalSummary, month) {
    if (!rows || !Array.isArray(rows) || rows.length === 0) {
        toast.info('No data available to export');
        return;
    }
    try {
        const formatMonth = (m) => {
            if (!m)
                return '';
            const [year, mon] = m?.split('-');
            const date = new Date(parseInt(year), parseInt(mon) - 1);
            return date?.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
        };
        const formatVariance = (value) => {
            const num = Number(value) || 0;
            return `${Math.abs(num)?.toFixed(2)}%`;
        };
        const formatCurrency = (value) => {
            const num = Number(value) || 0;
            return `$${num?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        };
        const formatCurrencyRounded = (value) => {
            const num = Math.round(Number(value) || 0);
            return `$${num?.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
        };
        const groupHeaders = ['', '', '', 'Revenue', '', '', 'ROAS', '', '', 'Commission'];
        const headers = ['Client', 'AM', 'MC', 'Goal', 'MTD', 'Variance', 'Goal', 'MTD', 'Variance', 'Baseline'];
        const data = rows.map((row) => [
            row.name || '',
            row.am || 'NA',
            MC_LABEL_MAP[row.mc || ''] || row.mc || '',
            formatCurrencyRounded(row.revenue?.goal),
            formatCurrencyRounded(row.revenue?.mtd),
            formatVariance(row.revenue?.variance_percent),
            (Number(row.roas?.goal) || 0)?.toFixed(2),
            (Number(row.roas?.mtd) || 0)?.toFixed(2),
            formatVariance(row.roas?.variance_percent),
            formatCurrency(row.commission?.baseline),
        ]);
        const summaryRow = [
            'Total Summary',
            '',
            '',
            formatCurrencyRounded(totalSummary?.revenue?.goal),
            formatCurrencyRounded(totalSummary?.revenue?.mtd),
            formatVariance(totalSummary?.revenue?.variance_percent),
            '-',
            '-',
            '-',
            '-',
        ];
        const numCols = headers.length;
        const monthDisplay = formatMonth(month);
        const titleText = `Account Performance${monthDisplay ? ` - ${monthDisplay}` : ''}`;
        const titleRow = [titleText, ...Array(numCols - 1).fill('')];
        const spacerRow = Array(numCols).fill('');
        const sheetData = [titleRow, spacerRow, groupHeaders, headers, ...data, summaryRow];
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
        // Title style
        if (worksheet['A1'])
            worksheet['A1'].s = titleStyle;
        // Merges
        worksheet['!merges'] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: numCols - 1 } },
            { s: { r: 2, c: 3 }, e: { r: 2, c: 5 } },
            { s: { r: 2, c: 6 }, e: { r: 2, c: 8 } },
        ];
        // Header styles
        for (let c = 0; c < numCols; c++) {
            const groupCell = XLSX.utils.encode_cell({ r: 2, c });
            const headerCell = XLSX.utils.encode_cell({ r: 3, c });
            if (worksheet[groupCell])
                worksheet[groupCell].s = groupHeaderStyle;
            if (worksheet[headerCell])
                worksheet[headerCell].s = columnHeaderStyle;
        }
        // Variance color styling for data rows
        const dataStartRow = 4;
        rows.forEach((row, index) => {
            const rowIndex = dataStartRow + index;
            // Revenue Variance (column 5)
            const revenueVarCell = XLSX.utils.encode_cell({ r: rowIndex, c: 5 });
            if (worksheet[revenueVarCell]) {
                const val = Number(row.revenue?.variance_percent) || 0;
                worksheet[revenueVarCell].s = val >= 0 ? positiveVarianceStyle : negativeVarianceStyle;
            }
            // ROAS Variance (column 8)
            const roasVarCell = XLSX.utils.encode_cell({ r: rowIndex, c: 8 });
            if (worksheet[roasVarCell]) {
                const val = Number(row.roas?.variance_percent) || 0;
                worksheet[roasVarCell].s = val >= 0 ? positiveVarianceStyle : negativeVarianceStyle;
            }
        });
        // Summary row styling
        const summaryRowIndex = dataStartRow + rows.length;
        for (let c = 0; c < numCols; c++) {
            const cellRef = XLSX.utils.encode_cell({ r: summaryRowIndex, c });
            if (worksheet[cellRef])
                worksheet[cellRef].s = summaryRowStyle;
        }
        // Summary variance color
        const summaryRevenueVarCell = XLSX.utils.encode_cell({ r: summaryRowIndex, c: 5 });
        if (worksheet[summaryRevenueVarCell] && totalSummary?.revenue?.variance_percent !== undefined) {
            const val = Number(totalSummary.revenue.variance_percent) || 0;
            worksheet[summaryRevenueVarCell].s = {
                ...summaryRowStyle,
                font: { ...summaryRowStyle.font, color: { rgb: val >= 0 ? '027A48' : 'B42318' } },
            };
        }
        // Column widths
        worksheet['!cols'] = [
            { wch: 25 }, { wch: 20 }, { wch: 15 }, { wch: 15 }, { wch: 15 },
            { wch: 12 }, { wch: 10 }, { wch: 10 }, { wch: 12 }, { wch: 15 },
        ];
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Account Performance');
        const safeMonth = month?.replace('-', '_') || 'all';
        XLSX.writeFile(workbook, `Account_Performance_${safeMonth}.xlsx`);
    }
    catch (error) {
        console.error('Failed to export:', error);
        toast.info('Failed to export. Please try again.');
    }
}
export default exportAccountPerformance;
